import styled from "styled-components";

export const Wrapper = styled.div`
  & .MuiPaper-root {
    margin-top: 24px;
    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
      margin: 32px 0;
    }
  }

  & .MuiButtonBase-root {
    padding: 0;
  }

  & .MuiAccordionSummary-root {
    justify-content: space-between;
  }
  & .MuiAccordionSummary-content {
    font-size: ${16 / 16}rem;
    margin: 16px 0;
    font-family: "Inter", sans-serif;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.greyscale.grey800};

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      margin: 20px 0;
    }
  }

  & .MuiPaper-elevation1 {
    box-shadow: none;

    &::before {
      content: none;
    }
  }

  & .MuiAccordionDetails-root{
    padding: 0;
  }
`;

export const ArticleWrapper = styled.div`
  & p {
    font-family: "Mulish", sans-serif;
    font-weight: 400;
    font-size: ${16 / 16}rem;
    color: ${({ theme }) => theme.palette.greyscale.grey400};
  }
`;
